import { get } from 'lodash';
import { Role } from '../../types';
import { useGetAccessTokenPayload } from './useGetAccessTokenPayload';

export const useGetUserRoleBusinessesIDs = (role?: Role | null) => {
  const tokenPayload = useGetAccessTokenPayload();

  const organizationsRoles = get(tokenPayload, 'organization_roles', {});
  const organization_attribute = get(tokenPayload, 'organization_attribute', {});

  if (!organizationsRoles || !organization_attribute || !role) return [];

  return Object.entries(organizationsRoles).reduce((acc, [organizationId, data]) => {
    const organizationRoles: Role[] = get(data, 'roles', []);
    if (!organizationRoles.includes(role)) return acc;

    const registerId = +get(
      organization_attribute,
      [organizationId, 'attributes', 'compliance_backend_business_id', 0],
      '',
    );

    return registerId ? [...acc, registerId] : acc;
  }, [] as number[]);
};
